<!-- Section 2: 3 cards per row -->
<div
    class="tw-py-[50px] tw-px-[28px] md:tw-px-[50px] lg:tw-px-[80px] tw-bg-[#024B3F0D]"
>
    <div
        class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 xl:tw-grid-cols-3 lg:tw-gap-[100px]- md:tw-gap-[40px] tw-gap-[20px] tw-w-fit tw-mx-auto tw-items-stretch"
    >
        <!-- Loop through response "cards" -->
        <div
            *ngFor="let card of toolsCards | slice : 0 : visibleCount"
            class="tw-w-full tw-h-full"
        >
            <!-- Child cards for tablet and desktop -->
            <app-comp-cards
                [gaPrefix]="gaPrefix"
                [image]="card.imagedesktop || card?.logo_url"
                [title]="card.institution"
                [subtitle]="card.title"
                [description]="card.description"
                [buttonText]="card.cta"
                [url]="card.url"
                (buttonClick)="openLink(card.url)"
                class="tw-hidden md:tw-block tw-h-full"
            ></app-comp-cards>

            <!-- Child cards for mobile -->
            <app-card-type-4
                [gaPrefix]="gaPrefix"
                [image]="card.imagedesktop || card?.logo_url"
                [title]="card.institution"
                [subtitle]="card.title"
                [description]="card.description"
                [buttonText]="card.cta"
                (buttonClick)="openLink(card.url)"
                class="tw-block md:tw-hidden tw-h-full"
            ></app-card-type-4>
        </div>
    </div>

    <!-- Show More Button -->
    <div
        class="tw-flex tw-justify-center tw-mt-8"
        *ngIf="visibleCount < toolsCards.length"
    >
        <button
            [attr.ga-event-id]="'tools_&_resources_show_more_button_jc3_click'"
            [attr.ga-event-category]="'JC3 Button'"
            [attr.ga-event-label]="'Tools & Resources - Show More Button Click'"
            ga-track="track"
            class="tw-bg-white tw-border tw-border-[#024B3F] tw-text-[#024B3F] tw-text-[16px] tw-font-medium tw-px-6 tw-py-2.5 tw-rounded-full tw-flex tw-items-center tw-gap-2 hover:tw-bg-[#024B3F] hover:tw-text-white transition"
            (click)="showMore()"
        >
            Show more
            <!-- Down Arrow Icon -->
            <svg
                xmlns="http://www.w3.org/2000/svg"
                class="tw-w-4 tw-h-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 9l-7 7-7-7"
                />
            </svg>
        </button>
    </div>
</div>
